<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="handleDialog" width="1200" class="common-dialog">
        <v-card color="#F4FEFB">
        <v-container fluid>
            <v-row justify="center">
                <v-col>
                    <v-container>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                               <label-component>ステータス</label-component>
                            </v-col>
                            <v-col cols="12" xl="8" class="d-flex">
                                <v-checkbox
                                  label="進行中"
                                  value="1"
                                  v-model="searchItem.status.progress"
                                ></v-checkbox>
                                <v-checkbox
                                  label="締結済み"
                                  value="3"
                                  v-model="searchItem.status.conclusion"
                                ></v-checkbox>
                                <v-checkbox
                                  label="却下"
                                  value="4"
                                  v-model="searchItem.status.rejected"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                               <label-component>開封状況</label-component>
                            </v-col>
                            <v-col cols="12" xl="8" class="d-flex">
                                <v-checkbox
                                  label="開封済"
                                  value="2"
                                  v-model="searchItem.openStatus.opened"
                                ></v-checkbox>
                                <v-checkbox
                                  label="未開封"
                                  value="1"
                                  v-model="searchItem.openStatus.unopened"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>種類</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <v-select
                                    v-model="searchItem.type.value"
                                    :items="searchItem.type.selects"
                                    outlined
                                    background-color="white"
                                ></v-select>
                            </v-col>
                        </v-row>
                       <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>件名</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <v-text-field v-model="searchItem.contract_name" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>管理番号</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <v-text-field v-model="searchItem.infoUpdate.controlNumber" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>契約開始日</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <date-picker-component v-model="searchItem.startDate"></date-picker-component>
                            </v-col>
                            <v-col cols="12" xl="2">
                                <label-component>契約終了日</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <date-picker-component v-model="searchItem.endDate"></date-picker-component>
                            </v-col>
                        </v-row>
                        <!-- アラート -->
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>アラート日</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <date-picker-component v-model="searchItem.alertDate"></date-picker-component>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>契約情報更新者</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <v-select
                                    v-model="searchItem.infoUpdate.value"
                                    :items="searchItem.infoUpdate.persons"
                                    outlined
                                    background-color="white"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>取引金額</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <v-text-field v-model="searchItem.infoUpdate.fromTransactionAmount" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                            </v-col>
                            <v-col cols="12" xl="1" class="between-mark">～</v-col>
                            <v-col cols="12" xl="4">
                                <v-text-field v-model="searchItem.infoUpdate.toTransactionAmount" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>契約情報更新日</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <date-picker-component v-model="searchItem.infoUpdate.date"></date-picker-component>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>最終更新者</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <v-select
                                    v-model="searchItem.lastUpdate.value"
                                    :items="searchItem.lastUpdate.persons"
                                    outlined
                                    background-color="white"
                                    text-align=left
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>最終更新日</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <date-picker-component v-model="searchItem.lastUpdate.date"></date-picker-component>
                            </v-col>
                        </v-row>
                        <v-row v-for="(userItem, index) in searchItem.userItems" :key="index" class="search-item">
                            <v-col cols="12" xl="2">
                                <label-component>{{ userItem['item_name'] }}</label-component>
                            </v-col>
                            <v-col cols="12" xl="4">
                                <v-text-field v-model="userItem['value']" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-col>
        </v-row>
    </v-container>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="blue" large v-on:click="search">
                    <slot name="ok-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</ValidationObserver>
</template>

<script>
export default {
    props: {
        // ダイアログの開閉
        addDialog: Boolean,
        searchItem: Object,
    },
    data() {
        return {
            // 検索項目
            item: null,
        };
    },    
    // 初期表示のデータ
    created : function() {
        this.item = {
                    // ステータス
                    status:this.searchItem.status?? '',
                    // 開封状況
                    openStatus:this.searchItem.openStatus?? '', 
                    // 種類
                    type: this.searchItem.type?? '',
                    // 件名
                    contract_name: this.searchItem.contract_name?? '',
                    // 契約開始日
                    startDate: this.searchItem.startDate?? '',
                    // 契約終了日
                    endDate: this.searchItem.endDate?? '',
                    // アラート日
                    alertDate: this.searchItem.alertDate?? '',
                    // 契約情報更新
                    infoUpdate: this.searchItem.infoUpdate?? '',
                    // 最終更新
                    lastUpdate: this.searchItem.lastUpdate?? '',
                    // ユーザー定義項目
                    userItems: this.searchItem.userItems?? '',
        };
    },
    computed: {
        handleDialog: {
            get() {
                return this.addDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:addDialog', value);
            }
        },
    },
    methods: {
            // 検索
            search() {
                this.$emit("success", this.searchItem);
            },        
    },
};
</script>>